<template>
  <div class="competencies-info-container">
    <div id="competencies-track" v-if="programmeId" :class="setModulesLayout ? 'grid-view': 'list-view'">
      <k-panel-competency-card v-for="comp in competencies" :key="comp.id"
        :competency="comp"
        @save-competency="saveCompetency(comp.id, $event)"
      />
    </div>
  </div>
</template>

<style>
#competencies-track .card-label {
  min-width: 85px;
}

#competencies-track .card-progress-container {
  display: flex;
  flex-direction: column-reverse;
  gap: 15px;
  text-align: right;
}

#competencies-track .panel-card-body {
  display: flex;
  flex-direction: column-reverse;
  gap: 10px;
}
</style>

<style scoped>
.competencies-info {
  padding-bottom: 10px;
  font-style: italic;
}
</style>

<script>
import TimeMixin from '@mixins/time-mixins';
import useProgrammeCompetencyStore from '@stores/programme-competency-store';
import KPanelCompetencyCard from './components/k-panel-competency-card.vue';

export default {
  mixins: [TimeMixin],

  components: {
    KPanelCompetencyCard,
  },

  props: {
    programmeId: {
      type: Number,
      required: true,
    },
    competencies: {
      type: Array,
      required: true,
    },
    setModulesLayout: Boolean,
  },

  data() {
    const competencyStore = useProgrammeCompetencyStore();
    return {
      competencyStore,
      updatingCompetency: false,
      now: undefined,
    };
  },

  mounted() {
    this.now = new Date();
  },

  watch: {
    updatingCompetency(newVal) {
      if (newVal) {
        this.$Loading.minimal();
      } else {
        this.$Loading.finish();
      }
    },
  },

  methods: {
    saveCompetency(competencyId, score) {
      this.updatingCompetency = true;
      this.$logger.info('Saving competency', { competencyId, score }, true);
      this.$http.post(`/api/curriculum/competencies/${competencyId}/scores`, { score })
        .then(response => {
          this.$logger.info('Competency saved', response.data, true);
          this.$ktoast.success('Competency score saved.');
          return this.competencyStore.fetchCompetencies(this.programmeId)
            .catch(error => {
              this.$logger.error('Error fetching updated competencies', undefined, error);
            });
        })
        .catch(error => {
          this.$logger.error('Error saving competency', undefined, error);
        }).then(() => {
          this.updatingCompetency = false;
        });
    },
  },
};
</script>
